import { useEffect, useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

/**
 * ScrollNav — floating half-page scroll controls for the public site.
 * Renders two circular buttons (Up / Down) fixed to the lower-right corner.
 * Smart visibility: Up hides at page top, Down hides at page bottom.
 * Public-only (mounted from PublicLayout, never AdminShell).
 */
export default function ScrollNav() {
  const [atTop, setAtTop] = useState(true);
  const [atBottom, setAtBottom] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const y = window.scrollY || document.documentElement.scrollTop;
      const viewport = window.innerHeight;
      const full = document.documentElement.scrollHeight;
      setAtTop(y < 40);
      setAtBottom(y + viewport >= full - 40);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  const halfPage = (direction) => {
    window.scrollBy({
      top: direction * window.innerHeight * 0.5,
      behavior: "smooth",
    });
  };

  return (
    <div
      className="fixed z-40 bottom-6 right-6 sm:bottom-8 sm:right-8 flex flex-col gap-3"
      data-testid="scroll-nav"
    >
      <button
        type="button"
        onClick={() => halfPage(-1)}
        aria-label="Scroll up half a page"
        data-testid="scroll-nav-up"
        className={`scroll-nav-btn ${atTop ? "scroll-nav-hidden" : "scroll-nav-visible"}`}
      >
        <ChevronUp className="h-4 w-4" strokeWidth={2.2} />
      </button>
      <button
        type="button"
        onClick={() => halfPage(1)}
        aria-label="Scroll down half a page"
        data-testid="scroll-nav-down"
        className={`scroll-nav-btn ${atBottom ? "scroll-nav-hidden" : "scroll-nav-visible"}`}
      >
        <ChevronDown className="h-4 w-4" strokeWidth={2.2} />
      </button>
    </div>
  );
}
